import { getApiUrl } from '../../config/development';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

export const getEvents = async () => {
  try {
    const token = await AsyncStorage.getItem('adminAuthToken') || await AsyncStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/events/radar`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch events');
    }

    return await response.json();
  } catch (error) {
    console.error('getEvents error:', error);
    throw error;
  }
};

export const createEvent = async (eventData) => {
  try {
    const token = await AsyncStorage.getItem('adminAuthToken') || await AsyncStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/events`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(eventData),
    });

    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to create event');
    }

    return await response.json();
  } catch (error) {
    console.error('createEvent error:', error);
    throw error;
  }
};

export const updateEvent = async (eventId, eventData) => {
  try {
    const token = await AsyncStorage.getItem('adminAuthToken') || await AsyncStorage.getItem('token');
    const response = await fetch(`${getApiUrl()}/events/admin/${eventId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(eventData),
    });

    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to update event');
    }

    return await response.json();
  } catch (error) {
    console.error('updateEvent error:', error);
    throw error;
  }
};

export const uploadEventImage = async (imageUri) => {
  try {
    const token = await AsyncStorage.getItem('adminAuthToken') || await AsyncStorage.getItem('token');
    
    const formData = new FormData();
    const filename = imageUri.split('/').pop() || 'image.jpg';
    
    if (Platform.OS === 'web') {
      try {
        console.log('[Upload] Fetching blob from:', imageUri);
        const resp = await fetch(imageUri);
        const blob = await resp.blob();
        console.log('[Upload] Blob fetched:', { size: blob.size, type: blob.type });
        
        // Use File constructor if available for better compatibility
        const file = new File([blob], filename, { type: blob.type || 'image/jpeg' });
        formData.append('image', file);
      } catch (e) {
        console.error('Failed to convert uri to blob:', e);
        throw new Error('Failed to process image: ' + e.message);
      }
    } else {
      const match = /\.(\w+)$/.exec(filename);
      const type = match ? `image/${match[1]}` : `image/jpeg`;
      formData.append('image', {
        uri: Platform.OS === 'ios' ? imageUri.replace('file://', '') : imageUri,
        name: filename,
        type: type,
      });
    }

    console.log('[Upload] Sending POST to:', `${getApiUrl()}/events/admin/upload`);
    const response = await fetch(`${getApiUrl()}/events/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        // Note: Do NOT set Content-Type here, the browser/RN will set it with boundary
      },
      body: formData,
    });

    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        console.error('[Upload] Server error response:', err);
        throw new Error(err.error || 'Failed to upload event image');
    }

    return await response.json();
  } catch (error) {
    console.error('uploadEventImage error:', error);
    throw error;
  }
};
